import { FacettenOptionInfo } from '../services/facetten/facetten-option-info';

export enum RegionKurzKursnet {
  BB = 'BRA',
  BE = 'BER',
  BW = 'BAW',
  BY = 'BAY',
  HB = 'BRE',
  HE = 'HES',
  HH = 'HAM',
  MV = 'MBV',
  NI = 'NDS',
  NW = 'NRW',
  RP = 'RPF',
  SH = 'SLH',
  SL = 'SAA',
  SN = 'SAC',
  ST = 'SAN',
  TH = 'THÜ'
}

// Langbezeichnung (z.B. Bayern) der Regionen
export enum RegionLang {
  BB = 'Brandenburg',
  BE = 'Berlin (Bundesland)',
  BW = 'Baden-Württemberg',
  BY = 'Bayern',
  HB = 'Bremen (Bundesland)',
  HE = 'Hessen',
  HH = 'Hamburg (Bundesland)',
  MV = 'Mecklenburg-Vorpommern',
  NI = 'Niedersachsen',
  NW = 'Nordrhein-Westfalen',
  RP = 'Rheinland-Pfalz',
  SH = 'Schleswig-Holstein',
  SL = 'Saarland',
  SN = 'Sachsen',
  ST = 'Sachsen-Anhalt',
  TH = 'Thüringen',
  iA = 'Österreich',
  iB = 'Belgien',
  iCH = 'Schweiz',
  iCZ = 'Tschechien',
  iD = 'Deutschland',
  iDK = 'Dänemark',
  iE = 'Spanien',
  iF = 'Frankreich',
  iGB = 'Großbritannien',
  iH = 'Ungarn',
  iI = 'Italien',
  iLU = 'Luxemburg',
  iN = 'Norwegen',
  iNL = 'Niederlande',
  iPL = 'Polen',
  iS = 'Schweden',
  iSK = 'Slowakei',
  iIRL = 'Irland',
  iP = 'Portugal',
  iFIN = 'Finnland',
  iSLO = 'Slowenien',
  iWORLD = 'Weitere Länder'
}

const mappedRegionen: { [key in RegionKurzKursnet]: RegionLang } = {
  [RegionKurzKursnet.BB]: RegionLang.BB,
  [RegionKurzKursnet.BE]: RegionLang.BE,
  [RegionKurzKursnet.BW]: RegionLang.BW,
  [RegionKurzKursnet.BY]: RegionLang.BY,
  [RegionKurzKursnet.HB]: RegionLang.HB,
  [RegionKurzKursnet.HE]: RegionLang.HE,
  [RegionKurzKursnet.HH]: RegionLang.HH,
  [RegionKurzKursnet.MV]: RegionLang.MV,
  [RegionKurzKursnet.NI]: RegionLang.NI,
  [RegionKurzKursnet.NW]: RegionLang.NW,
  [RegionKurzKursnet.RP]: RegionLang.RP,
  [RegionKurzKursnet.SH]: RegionLang.SH,
  [RegionKurzKursnet.SL]: RegionLang.SL,
  [RegionKurzKursnet.SN]: RegionLang.SN,
  [RegionKurzKursnet.ST]: RegionLang.ST,
  [RegionKurzKursnet.TH]: RegionLang.TH
};

export const orderedRegionen = Object.entries(mappedRegionen)
  .map(([id, bezeichnung]) => {
    return {
      id,
      bezeichnung
    } as FacettenOptionInfo;
  })
  .sort((a, b) => {
    if (a.bezeichnung < b.bezeichnung) {
      return -1;
    }
    if (a.bezeichnung > b.bezeichnung) {
      return 1;
    }
    return 0;
  });
